import { Button, CircularProgress } from "@mui/material";
import { useCallback, useState } from "react";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";
import {
  TeamifiedTask,
  useUpdateTaskMutation,
} from "../../../redux/Task/TaskApi";
import { userAccess } from "../../../utils/CommonFunction";
import CandidateMoveConfirmModal from "../../HireV3/CandidateMoveConfirmModal";
import CandidateMoveConfirmModalShortlist from "../../HireV3/CandidateMoveConfirmModalShortlist";

type Props = {
  candidate?: CandidateDetails;
  task: TeamifiedTask & { taskId: number };
};

const MoveCandidate = ({ candidate, task }: Props) => {
  const [modalStatus, setModalStatus] = useState<
    "Shortlist" | "Open" | "Close"
  >("Close");
  const [updateTask, updateTaskMutating] = useUpdateTaskMutation();

  const { userId, firstName, lastName } = userAccess();

  const submitAcceptCandidate = useCallback(() => {
    if (task) {
      updateTask({
        ...task,
        completedAction: JSON.parse(task.actionsJson)[0].id,
        id: task.taskId,
        completedBy: userId,
        completedByName: firstName + " " + lastName,
      });
    }
  }, [firstName, lastName, task, updateTask, userId]);

  const handleOpen = useCallback(() => {
    if (!candidate) return;
    if (candidate.stage === "shortlist") {
      setModalStatus("Shortlist");
      return;
    } else {
      setModalStatus("Open");
    }
  }, [candidate]);

  const handleClose = useCallback(() => setModalStatus("Close"), []);

  return (
    <>
      <CandidateMoveConfirmModalShortlist
        cancel={handleClose}
        isLoading={updateTaskMutating.isLoading}
        positiveResponse={submitAcceptCandidate}
        showModal={modalStatus === "Shortlist"}
        text="Are you sure you want to move this candidate to next stage?"
        details={candidate}
        btnText="Save and move to next stage"
      ></CandidateMoveConfirmModalShortlist>
      <CandidateMoveConfirmModal
        cancel={handleClose}
        isLoading={updateTaskMutating.isLoading}
        positiveResponse={submitAcceptCandidate}
        showModal={modalStatus === "Open"}
        text="Are you sure you want to move this candidate to next stage?"
      ></CandidateMoveConfirmModal>
      <Button
        variant="contained"
        onClick={handleOpen}
        disabled={updateTaskMutating.isLoading}
      >
        {updateTaskMutating.isLoading ? (
          <CircularProgress size={20} />
        ) : (
          "Move to next stage"
        )}
      </Button>
    </>
  );
};

export default MoveCandidate;
